var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-sections-inner-grid"},[(_vm.isCustomer)?_c('CompanySetting'):_vm._e(),_c('UserDataSetting'),_c('EmailSetting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }